
import moment from 'moment-timezone';

const formatTime = (value, formatType) => {
    if (!value) {
        return '';
    }

    const momentObj = moment(value);
    switch (formatType) {
        case 'd':
            return momentObj.format('ll');
        case 'dt':
            return momentObj.format('MMM D, h:mm A');
        default:
            return momentObj.format('lll');
    }
};

export default formatTime;



// WEBPACK FOOTER //
// ./src/utils/formatTime.js